namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeSelectSellingPriceFg {
        SelectSellingPriceFg = 0,
        SelectSellingPriceFg1 = 1
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeSelectSellingPriceFg, 'GeniuzPOS.Administration.PsParaGenTypeSelectSellingPriceFg', 'Administration.PsParaGenTypeSelectSellingPriceFg');
}
